import React, { ChangeEvent } from 'react';
import { Button, Input, Typography } from 'antd';

interface MfaVerificationFormProps {
  verificationCode: string;
  setVerificationCode: (code: string) => void;
  setAuthStep: (step: 'login' | 'mfa-setup' | 'mfa-verification') => void;
  handleVerifyMfa: () => void;
  verifying: boolean;
  buttonStyle: React.CSSProperties;
  buttonBackStyle: React.CSSProperties;
  inputStyle: React.CSSProperties;
}

const MfaVerificationForm: React.FC<MfaVerificationFormProps> = ({
  verificationCode,
  setVerificationCode,
  setAuthStep,
  handleVerifyMfa,
  verifying,
  buttonStyle,
  buttonBackStyle,
  inputStyle,
}) => {
  return (
    <div className='space-y-6'>
      <h2 className='text-xl font-semibold'>MFA Verification Required</h2>
      <p>Enter the verification code from your authenticator app</p>

      <div className='space-y-4'>
        <div>
          <Typography.Text>Verification Code *</Typography.Text>
          <Input
            value={verificationCode}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setVerificationCode(e.target.value.replace(/[^0-9]/g, ''))
            }
            placeholder='Enter 6-digit code'
            maxLength={6}
            type='tel'
            autoFocus
            onPressEnter={handleVerifyMfa}
            style={inputStyle}
          />
        </div>

        <div className='flex space-x-4'>
          <Button
            onClick={() => {
              setAuthStep('login');
              setVerificationCode('');
            }}
            className='flex-1'
            style={buttonBackStyle}
            type='default'
          >
            Back
          </Button>
          <Button
            type='primary'
            onClick={handleVerifyMfa}
            className='flex-1'
            loading={verifying}
            style={buttonStyle}
          >
            Verify
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MfaVerificationForm;
